import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import AppProvider from 'context/providers/AppProvider';

// import AuthProvider
import createStore from 'react-auth-kit/createStore';
import AuthProvider from 'react-auth-kit';
import refresh from "./oauthRefresh";

// import Translation
import './i18n'; // Translation Config File

// store for AuthProvider
const store = createStore({
	authName: '_auth',
	authType: 'localstorage',
	//cookieDomain: window.location.hostname,
	//cookieSecure: window.location.protocol === 'https:',
	refresh: refresh,
	debug: true
});

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
	<AuthProvider store={store}>
		<AppProvider>
			<App />
		</AppProvider>
	</AuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
